import React from 'react';

// components
import Image from 'next/image';
import VisibleLoading from '@/components/utilities/VisibleLoading';
import Sms from './Sms';

// utilities
import { getImagePath } from '@/utils/images';

const SmsHeroBlock = ({ image, sms }) => {
  return (
    <div className="relative">
      <VisibleLoading delay={75}>
        {({ ref, className }) => (
          <div
            ref={ref}
            className={`relative mx-auto h-[286px] w-[228px] shrink-0 lg:h-[490px] lg:w-[390px] lg:scale-100 ${className || ''}`.trim()}
          >
            {sms && (
              <VisibleLoading delay={500} direction="right">
                {({ ref, className }) => <Sms innerRef={ref} {...sms} classNameContainer={className} />}
              </VisibleLoading>
            )}
          </div>
        )}
      </VisibleLoading>
      {image && (
        <Image
          src={getImagePath(image)}
          alt={image.alternativeText || 'Phone'}
          width={image.width}
          height={image.height}
          sizes="100vw"
          className="absolute top-0 left-0 -z-10 h-auto w-full object-cover xl:block"
          priority={true}
          fetchPriority="high"
        />
      )}
    </div>
  );
};
export default SmsHeroBlock;
